export type DaySlotChooserStyle = 'Simple List' | 'Calendar';
export const DaySlotChooserStyle = {
  SimpleList: 'Simple List' as DaySlotChooserStyle,
  Calendar: 'Calendar' as DaySlotChooserStyle,
};
